import { render, staticRenderFns } from "./Records.vue?vue&type=template&id=cff2c87c&scoped=true&"
import script from "./Records.vue?vue&type=script&lang=js&"
export * from "./Records.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/components/timeline/custom-timeline.css?vue&type=style&index=0&id=cff2c87c&scoped=true&lang=css&"
import style1 from "./Records.vue?vue&type=style&index=1&id=cff2c87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff2c87c",
  null
  
)

export default component.exports